import React, { useEffect } from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faComments } from '@fortawesome/free-solid-svg-icons';
import Cookies from 'js-cookie';
import { Button } from 'reactstrap';

const SignupServiceInfo = () => {
    const iconStyle = {
        marginRight: '.5rem',
    };

    const isWidgetEnabled = process.env.REACT_APP_ENABLE_ATLASSIAN_WIDGET === 'true' && Cookies.get('bigfoot_personalization-consent') === 'true';

    const handleHelpClick = () => {
        const widgetIframe = document.getElementById('jsd-widget');
        if (widgetIframe) {
            // Apply visual cue (shake/bounce animation)
            widgetIframe.style.transition = 'transform 0.1s ease-in-out, box-shadow 0.3s ease-in-out';

            // Simple shake animation using timeouts
            let shake = 0;
            const interval = setInterval(() => {
                const rotation = shake % 2 === 0 ? 3 : -3;
                widgetIframe.style.transform = `rotate(${rotation}deg) scale(1.1)`;
                shake++;
                if (shake > 5) {
                    clearInterval(interval);
                    widgetIframe.style.transform = 'scale(1)';
                    // Remove glow after a short delay
                    setTimeout(() => {
                        widgetIframe.style.boxShadow = 'none';
                    }, 1000);
                }
            }, 50);
        } else {
            console.error("Bigfoot: Atlassian widget iframe not found.");
        }
    };

    return (
        <>
            <h2>Fragen zum Bewerbungsprozess?</h2>
            {isWidgetEnabled ? (
                <>
                    <p>Unser <strong>digitaler Assistent</strong> ist jederzeit für Sie da. Falls er einmal nicht weiterweiß, können Sie Ihr Anliegen direkt über den Chat an unser Team übermitteln. Klicken Sie auf <strong>Hilfe-Chat öffnen</strong>, um zu starten.</p>
                    <span className="visually-hidden">
                        Erreichbar per Telefon unter der Nummer 0841804690 oder per E-Mail unter der Adresse hilfe@swi-umweltpreis.de.
                    </span>
                </>
            ) : (
                <>
            <p>
                Kontaktieren Sie uns <strong>werktags von 9:00 bis 17:00 Uhr</strong> via
                Telefon oder E-Mail.
            </p>
                <a
                    className="anl_signup--telephone-number d-block"
                    href="tel:+49841804690"
                >
                    <FontAwesomeIcon
                        icon={faPhone}
                        style={iconStyle}
                        fixedWidth
                    />
                    <span className="visually-hidden">
                        Erreichbar per Telefon mit der Nummer:
                    </span>
                    0841 80-4690
                </a>
                <a
                    className="anl_signup--email d-block mt-2"
                    href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL || "hilfe@swi-umweltpreis.de"}`}
                >
                    <FontAwesomeIcon
                        icon={faEnvelope}
                        style={iconStyle}
                        fixedWidth
                    />
                    <span className="visually-hidden">
                        Oder per E-Mail mit der Adresse:
                    </span>
                    {`${process.env.REACT_APP_SUPPORT_EMAIL || "hilfe@swi-umweltpreis.de"}`}
                </a>
                </>
            )}
        </>
    );
};

export default SignupServiceInfo;